import { DefaultService } from "../DefaultService";

export default class B2BClienteSovisService extends DefaultService {
    constructor(http, router, env) {
        super(http, router, env)
    }

    find(id) {
		return this._http.get(`${this._env}/b2b/b2bclientesovis/${id}.json`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.handleError(err);
        });
	}

    save(file, form) {
        const unifiedData = new FormData();

        unifiedData.append("file", file);
        unifiedData.append("clienteSovisInfo", new Blob([JSON.stringify(form)],
        {
            type: "application/json"
        }));
        unifiedData.append("clienteSovisInfo", form)

        const requestOptions = {
            method: 'POST',
            headers: Object.assign(this._headers.headers),
            body: unifiedData
        }

        delete requestOptions.headers["Content-Type"];
        
		return this._http.post(`${this._env}/b2b/b2bclientesovis`, unifiedData, requestOptions).then(res => {
            return res.body;
        }, err => {
            this.handleError(err);
        });
    }
}